var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { deleteMedicationList } from '../../Async/MedicationListsAsync';
import { Button, ButtonGroupStyle, ButtonMode, ButtonSize, ButtonVariant } from '../../Components/Button';
import { DeleteDialog } from '../../Components/DeleteDialog/DeleteDialog';
import { TrashCanIcon } from '../../Components/Icons';
import { displayError, displayMessage } from '../../Config/ApplicationConfig';
import { MedicationLocale } from '../../Medications.en';
import { getFirstErrorMessageFromApiError, isDomainValidationError } from '../../Shared/DomainValidationFunctions';
import { iconLight } from '../../Styles/Colours';
export var DeleteMedicationListButton = function (props) {
    var medicationList = props.medicationList, onDelete = props.onDelete, buttonProps = __rest(props, ["medicationList", "onDelete"]);
    var _a = __read(useState(false), 2), showDelete = _a[0], setShowDelete = _a[1];
    var _b = __read(useState(false), 2), deleting = _b[0], setDeleting = _b[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, __assign({}, buttonProps, { testId: props.testId, size: ButtonSize.small, mode: ButtonMode.border, variant: ButtonVariant.danger, buttonGroup: ButtonGroupStyle.Right, startIcon: React.createElement(TrashCanIcon, { noPadding: true, size: '20', color: iconLight }), onClick: function () {
                setShowDelete(true);
            } }), "Delete"),
        showDelete && (React.createElement(DeleteDialog, { title: 'Delete medication list', testId: 'delete-medication-list', disabled: deleting, onCancel: function () {
                setShowDelete(false);
            }, onOk: function () { return __awaiter(void 0, void 0, void 0, function () {
                var err_1, errorMessage;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setDeleting(true);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, deleteMedicationList(medicationList.id)];
                        case 2:
                            _a.sent();
                            displayMessage('Mediation list removed');
                            onDelete();
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            errorMessage = 'Unable to remove medication list';
                            if (isDomainValidationError(err_1)) {
                                errorMessage = getFirstErrorMessageFromApiError(err_1, MedicationLocale);
                            }
                            displayError(errorMessage);
                            setDeleting(false);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); } },
            "Are you sure you want to remove ",
            props.medicationList.name,
            "?"))));
};
